<template>
  <div class="fixed_page" id="blurry">
    <div class="get-started">
      <div class="fixed_page">
        <h1 class="how_works_title">{{ getTranslations.visitor_visitor_header_how_it_works }}</h1>
        <div class="how-it-works__content">

          <div class="how_it_works_box">
            <h1>{{ getTranslations.visitor_how_it_works_register }}</h1>
            <img class="ti_jackpot no_anime" src="/static/images/how_it_works/Register0.svg" alt="Register">
            <p>{{ getTranslations.visitor_how_it_works_text }}</p>
          </div>

          <div class="circle_background">
            <div class="how_it_works_box second">
              <h1>{{ getTranslations.visitor_how_it_works_play_game_and_win }}</h1>
              <img src="/static/images/how_it_works/Play.svg" class="how_it_works_img" alt="Play">
              <p>{{ getTranslations.visitor_how_it_works_play_game_and_win_text }}</p>
            </div>
            <div class="how_it_works_box" v-if="!hideForExternalRedirectionProjects()">
              <h1>{{ getTranslations.visitor_how_it_works_unlock_coins }}</h1>
              <img src="/static/images/how_it_works/Collect.svg" alt="Collect">
              <p>{{ getTranslations.visitor_how_it_works_unlock_coins_text }}</p>
            </div>
            <div class="how_it_works_box">
              <h1>{{ getTranslations.visitor_how_it_works_improve }}</h1>
              <img src="/static/images/how_it_works/Skills.svg" class="how_it_works_img" alt="Skills">
              <p>
                {{ getTranslations.visitor_how_it_works_improve_text }}
              </p>
            </div>

            <div class="how_it_works_box" v-if="!hideForExternalRedirectionProjects()">
              <h1>{{ getTranslations.visitor_how_it_works_win_the_jackpot }}</h1>
              <img src="/static/images/how_it_works/Prizes.svg" class="how_it_works_img" alt="Prizes">
              <p>{{ getTranslations.visitor_how_it_works_win_the_jackpot_text }}</p>
            </div>

            <div class="faq-container" v-if="getTranslations.components_how_it_works_frequently_asked_questions">
              <h2 class="faq-title">{{ getTranslations.components_how_it_works_frequently_asked_questions }}</h2>
              <div class="faq">
                <div class="faq-item">
                  <button class="faq-question"><span class="icon"></span>
                    {{ getTranslations.faq_question_2 }}
                  </button>
                  <div class="faq-answer">
                    <p>{{ getTranslations.project_faq_answer_2 }}</p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    <span class="icon"></span>
                    {{ getTranslations.faq_question_3 }}
                  </button>
                  <div class="faq-answer">
                    <p>{{ getTranslations.project_faq_answer_3 }}</p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    <span class="icon"></span>
                    {{ getTranslations.faq_question_5 }}
                  </button>
                  <div class="faq-answer">
                    <p>{{ getTranslations.project_faq_answer_5 }}</p>
                  </div>
                </div>

                <div class="faq-item">
                  <button class="faq-question">
                    <span class="icon"></span>
                    {{ getTranslations.faq_question_6 }}
                  </button>
                  <div class="faq-answer">
                    <p>{{ getTranslations.project_faq_answer_6 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'HowItWorks',
  data() {
    return {
      imageTop: '/ext/skin/top_icon.png',
    };
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'availableIntegrations',
      'integrationHeader',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
  mounted() {
    this.initScrollHandler();
    this.initFaqAccordion();
  },
  methods: {
    /* eslint-disable */
    initScrollHandler() {
      window.addEventListener('scroll', () => {
        const scroll = window.scrollY;
        const gotoTop = document.querySelector('.goto-top');
        if (gotoTop) {
          if (scroll > 500) {
            gotoTop.style.display = 'block';
          } else {
            gotoTop.style.display = 'none';
          }
        }
      });
    },
    initFaqAccordion() {
      this.$nextTick(() => {
        document.querySelectorAll('.faq-question').forEach(button => {
          button.addEventListener('click', () => {
            const faqItem = button.closest('.faq-item');
            const answer = faqItem.querySelector('.faq-answer');

            // Close any currently open item
            const openItem = document.querySelector('.faq-item.open');
            if (openItem && openItem !== faqItem) {
              const openAnswer = openItem.querySelector('.faq-answer');
              openAnswer.style.height = openAnswer.scrollHeight + 'px';
              requestAnimationFrame(() => {
                openAnswer.style.height = '0px';
                openAnswer.style.opacity = '0';
              });
              openItem.classList.remove('open');
            }

            if (faqItem.classList.contains('open')) {
              // Close current item
              answer.style.height = answer.scrollHeight + 'px';
              requestAnimationFrame(() => {
                answer.style.height = '0px';
                answer.style.opacity = '0';
              });
              faqItem.classList.remove('open');
            } else {
              // Open current item
              answer.style.height = answer.scrollHeight + 'px';
              answer.style.opacity = '1';
              faqItem.classList.add('open');

              answer.addEventListener('transitionend', () => {
                if (faqItem.classList.contains('open')) {
                  answer.style.height = 'auto';
                }
              }, { once: true });
            }
          });
        });
      });
    },
    imageErrorHandler() {
      this.imageTop = 'static/images/top_icon.png';
    },
    checkTopButton() {
      window.scrollTo(0, 0);
    },
    hideForExternalRedirectionProjects() {
      return this.integrationHeader === this.availableIntegrations.ROSHAN_AFG.name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue